import {Geofence, GeofenceEntity} from "../../../model/geofence";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type GeofenceSelectorProps = {};

export const geofencesSelector = () => createSelector(
  [getUseQueryResultData<Geofence[]>],
  (data) => {
    return selectGeofencesAndTransform(
      data ?? [], {}
    );
  }
);

export const geofenceSelector = () => createSelector(
  [getUseQueryResultData<Geofence>],
  (data) => {
    return data ? transformGeofence(data) : undefined;
  }
);

export const selectGeofences = (values?: Geofence[], selector?: GeofenceSelectorProps): Geofence[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformGeofence = (value: Geofence): GeofenceEntity => {
  return GeofenceEntity.from(value)
}

export const selectGeofencesAndTransform = (values?: Geofence[], selector?: GeofenceSelectorProps): GeofenceEntity[] => {
  const selected = selectGeofences(values, selector);
  return selected.map(transformGeofence);
};
